import React, {useEffect} from 'react'
import { Col, Row } from "reactstrap";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {showLoader} from "../../../components/loader/loader";
import {ADD_STATE, REMOVE_STATE, setApp, setForm, setUdn} from "../../../redux/actions/generics/IndexedActions";
import TypeServicesList from "./_list";


// components

// actions

const TypeServices = props => {
    const path = props.path || 'clasificators/typeServices';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);


    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (udn) {
            props.setUdn(path, udn);
        }
    },[]);


    return <>
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    {componentState && <TypeServicesList path={path}/>}
                </Col>
            </Row>
        </div>
    </>
}


const mapStateToProps = state => ({});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setForm,
    setApp,
});

export default connect(mapStateToProps, mapActionsToProps)(TypeServices)